<template>
  <div class="header">
    <header
      class="fixed w-100 brdr-bottom-0 bg-cl-primary"
      :class="{ 'site-header--transformed': scrollTop > 20 }"
    >
      <div :class="headerBackground">
        <shop-info :class="classHeader" v-if="!isOffice()"/>
      </div>
      <div class="container-fluid main-top-header px15" style="box-sizing: border-box;">
        <loader :isheader="true" />
        <div class="row between-xs middle-xs nav_rwd" style="height: 100%;" v-show="!isCheckoutPage || isThankYouPage">
          <div class="col-md-9 col-xs-2 middle-xs">
            <div class="flex" style="align-items:flex-start;width:100%;">
              <div class="pt5 px15 pointer hidden-xs">
                <logo :width="scrollTop > 20 ? '112px' : '144px'" height="auto" />
              </div>

              <hamburger-icon class="px5 py10 mx5 icon bg-cl-transparent pointer visible-xs" />
              <div class="inline-flex menu_position-rwd" style="flex:2;flex-wrap:nowrap;padding-top:6px;">
                <div class="inline-flex">
                <button
                  type="button"
                  class="menu-item relative desktop-only bg-cl-transparent brdr-none inline-flex hidden-xs"
                  v-for="(category) in visibleCategories()"
                  :class="{
                    'with-submenu':
                      category.children_data && category.children_data.length
                  }"
                  :key="category.slug"
                  @mouseenter="activeSubMenu = category.id"
                  @mouseleave="activeSubMenu = null"
                >
                  <router-link
                    class="menu-link main-menu-item"
                    :class="[
                    { active: activeSubMenu == category.id && !isOffice() }, 
                    {active2: activeSubMenu == category.id && isOffice() }]"
                    :aria-label="$t('Show subcategories')"
                    :data-testid="category.id"
                    :to="localizedRoute({
                      name: 'category',
                      params: { id: category.id, slug: category.url_path }
                    })"
                    @click="toggleSubMenu(category.id)"
                  >{{ category.name }}</router-link>
                  <sub-category
                    v-show="activeSubMenu === category.id"
                    :category-links="category.children_data"
                    :id="category.id"
                    :parent-slug="category.slug"
                    :parent-name="category.name"
                    class=""
                  />
                </button>
                </div>
                <div class="inline-flex">
                <button
                  type="button"
                  class="menu-item desktop-only relative bg-cl-transparent brdr-none inline-flex hidden-xs"
                  v-for="(menuItem, index) in getCmsData()"
                  :key="index"
                  @mouseenter="activeSubMenu = menuItem.displayName"
                  @mouseleave="activeSubMenu = null"
                >
                  <a
                    class="menu-link main-menu-item"
                    :class="[
                    { active:  activeSubMenu == menuItem.displayName && !isOffice() }, 
                    { active2:  activeSubMenu == menuItem.displayName && isOffice() }] "
                    :href="getUrl(menuItem)"
                    :target="getTarget(menuItem)"
                  >
                    {{ menuItem.displayName }}
                  </a>
                </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-2 visible-xs" style="padding-left:0px;">
            <search-icon class="mb5 mx5 icon pointer header-icon-btn" />
          </div>
          <div class="col-md-4 col-xs-4 center-xs mobi-logo visible-xs pt5" style="padding-left:0px;padding-right:10px;">
            <div class="visible-xs">
              <logo width="100%" height="41px" />
            </div>
          </div>
          <div class="col-xs-2 visible-xs">
            <wishlist-icon class="mb5 mx5 icon pointer header-icon-btn" />
          </div>
          <div class="col-xs-2 visible-xs pr15">
            <microcart-icon class="mb5 mx5 icon pointer header-icon-btn" />
          </div>
          <!-- <div class="col-xs-2 visible-xs">
            <language-switcher v-if="multistoreEnabled" />
          </div> -->
          <div class="col-md-3 col-xs-2 end-xs hidden-xs">
            <div class="inline-flex right-icons pr15" style="align-items: center;">
              <search-icon class="p10 mx5 icon hidden-xs pointer header-icon-btn" :class="headerIconBtn" />
              <wishlist-icon class="p10 mx5 icon hidden-xs pointer header-icon-btn" :class="headerIconBtn" />
              <!-- <compare-icon class="p10 mb5 mx5 icon hidden-xs pointer header-icon-btn" /> -->
              <microcart-icon class="p10 mx5 icon pointer header-icon-btn" :class="headerIconBtn" />
              <account-icon class="mx5 icon hidden-xs pointer header-icon-btn" :class="headerIconBtn" />

              <!-- commented on for concealment in connection with task BPB2C-135 -->
              <!-- <language-dropdown class="mx5 hidden-xs" /> -->
            </div>
          </div>
        </div>
        <div class="row between-xs middle-xs px15 py5 checkout" v-show="isCheckoutPage && !isThankYouPage">
          <div class="col-xs-5 col-md-3 hidden-xs">
            <div>
              <router-link
                :to="localizedRoute('/')"
                class="cl-white links py10 px20 bg-cl-mine-shaft checkout-links"
              >
                {{ $t('Return to shopping') }}
              </router-link>
            </div>
          </div>
          <div class="col-xs-5 col-md-6 center-xs mobi-logo">
            <logo width="104px" height="41px" />
          </div>
          <div class="col-xs-7 col-md-3 end-xs">
            <div>
              <a
                v-show="!currentUser"
                href="#"
                @click.prevent="gotoAccount"
                class="cl-white links py10 px20 bg-cl-mine-shaft checkout-links"
              >{{ $t('Login to your account') }}</a>
              <span v-show="currentUser">{{ $t('You are logged in as {firstname}', currentUser) }}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- <cms-block-chunk class="social-links" :identifier="`c_FOOTER_MEDIA`" /> -->
    <social-links></social-links>
    <div class="header-placeholder" :class="{ 'site-header--transformed': scrollTop > 20 }" />
  </div>
</template>

<script>
import config from 'config'
import { router } from '@vue-storefront/core/app'
import { mapGetters, mapState } from 'vuex'
import CurrentPage from 'theme/mixins/currentPage'
import Loader from 'theme/components/core/Loader.vue'
import AccountIcon from 'theme/components/core/blocks/Header/AccountIcon'
import CompareIcon from 'theme/components/core/blocks/Header/CompareIcon'
import HamburgerIcon from 'theme/components/core/blocks/Header/HamburgerIcon'
import SubCategory from 'theme/components/core/blocks/Header/SubCategory';
import Logo from 'theme/components/core/Logo'
import MicrocartIcon from 'theme/components/core/blocks/Header/MicrocartIcon'
import SearchIcon from 'theme/components/core/blocks/Header/SearchIcon'
import WishlistIcon from 'theme/components/core/blocks/Header/WishlistIcon'
import SocialLinks from 'theme/components/core/blocks/Header/SocialLinks'
import CmsBlockChunk from 'theme/components/core/blocks/Cms/BlockChunk'
import LanguageDropdown from 'theme/components/core/blocks/Switcher/LanguageDropdown'
import RootCateogry from 'theme/mixins/rootCategory'
import isMobile from 'theme/mixins/isMobile'
import { isServer } from '@vue-storefront/core/helpers'
import LanguageSwitcher from 'theme/components/core/blocks/Switcher/Language'
import ShopInfo from "theme/components/theme/blocks/Static/ShopInfo"
import { isOfficeShop } from 'theme/helpers'
export default {
  name: 'Header',
  components: {
    AccountIcon,
    CompareIcon,
    HamburgerIcon,
    Logo,
    MicrocartIcon,
    SearchIcon,
    WishlistIcon,
    SubCategory,
    CmsBlockChunk,
    SocialLinks,
    LanguageDropdown,
    LanguageSwitcher,
    ShopInfo,
    Loader
  },
  mixins: [CurrentPage, RootCateogry, isMobile],
  data () {
    return {
      config,
      headerIconBtn: '',
      headerBackground: '',
      classHeader: '',
      navVisible: true,
      isScrolling: false,
      scrollTop: 0,
      lastScrollTop: 0,
      navbarHeight: 54,
      // New data for menu
      cmsBlockIdentifier: 'm_TOP_MENU',
      activeSubMenu: null,
      menus: [],
      showSearchResult: false,
      allCategories: []
    }
  },
  computed: {
    ...mapState({
      isOpenLogin: state => state.ui.signUp,
      currentUser: state => state.user.current
    }),
    isThankYouPage () {
      return this.$store.state.checkout.isThankYouPage
        ? this.$store.state.checkout.isThankYouPage
        : false
    },
    multistoreEnabled () {
      return config.storeViews.multistore
    }
  },
  beforeMount() {
		window.addEventListener('scroll', this.onWindowScroll)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onWindowScroll)
	},
  async created () {
    let categories = await this.getAllCategories()
    this.allCategories = categories.items 
    this.$store.dispatch('cmsBlock/single', {
      key: 'identifier',
      value: this.cmsBlockIdentifier
    })
  },
  methods: {
    async getAllCategories () {
      return await this.$store.dispatch('category/list', {
        sort: 'priority:desc',
        skipCache: true,
        includeFields: this.$store.state.config.entities.optimize
          ? this.$store.state.config.entities.category.includeFields
          : null
      })
    },
    visibleCategories () {
      let catalog = this.$route.meta.category
      if (this.isOffice()) {        
        catalog = config.rootcategories.biuro  
      } else {
        catalog = config.rootcategories.drukowanie        
      }
      const result = this.allCategories.filter(op => {
        return op.level === 2 && op.path.startsWith(catalog);
      });

      return result.filter(category => {
        return category.is_active
      });
    },
    getCmsData () {
      let __response = this.$store.getters[`cmsBlock/cmsBlockIdentifier`](
        this.cmsBlockIdentifier
      );
      if (__response) {
        const result = JSON.parse(__response.content).filter(e => {          
          if (typeof e.categorySlug === 'undefined') {
            return true;
          } else if (e.categorySlug !== this.getRootCategorySlug) {
            return false;
          }
          return true;
        });        
        return result
      }
      return [];
    },
    onWindowScroll() {
			this.scrollTop = (document.documentElement).scrollTop
		},
    gotoAccount () {
      this.$bus.$emit('modal-toggle', 'modal-signup')
    },
    hasScrolled () {
      this.scrollTop = window.scrollY
      if (
        this.scrollTop > this.lastScrollTop &&
        this.scrollTop > this.navbarHeight
      ) {
        this.navVisible = false
      } else {
        this.navVisible = true
      }
      this.lastScrollTop = this.scrollTop
    },
    // Call for home menu
    getTarget (menuItem) {
      if (typeof menuItem.url === 'undefined') {
        return '_self';
      }
      if (menuItem.url.indexOf('http://') > -1) {
        return '_blank';
      }
      if (menuItem.url.indexOf('https://') > -1) {
        return '_blank';
      }
      return '_self'
    },
    onEscapePress () {
      this.closeMenu();
    },
    openMenu (id) {
      this.activeSubMenu = id;
      // this.$store.commit('ui/setOverlay', true)
    },
    closeMenu () {
      this.activeSubMenu = null;
      // this.$store.commit('ui/setOverlay', false)
    },
    toggleSubMenu (id) {
      if (this.activeSubMenu === id) {
        this.closeMenu();
      } else {
        this.openMenu(id);
      }
    },
    isOffice () {
      if (!isServer && window && window.location.pathname.startsWith(config.site.office_path)) {
        return true
      } else {
        return false
      }    
    },
    getUrl (menuItem) {      
      if (menuItem.linkType) {
        let baseUrl = this.isOffice ? config.site.office_path : config.baseUrl
        baseUrl = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'
        return baseUrl + 'i/' + menuItem.slug
      }
      return menuItem.url;
    }
  },
  mounted () {
    let catalog_design = this.$route.meta.category;
    if (!this.isOffice()) {
      this.headerIconBtn = 'header-icon-btn';
      this.headerBackground = 'site-header__top';
      this.classHeader = 'shop-info'
    } else {
      this.headerIconBtn = 'header-icon-btn_office';
      this.headerBackground = 'site-header__top-office';
      this.classHeader = 'shop-office'
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/variables/grid';
@import '~theme/css/variables/typography';
@import '~theme/css/helpers/functions/color';
$color-icon-hover: color(secondary, $colors-background);

header {
  height: 112px;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  position: fixed;
  background-color: transparent;
  transition: all 0.2s ease-out;
  &.is-visible {
    top: 0;
  }

  .main-top-header {
    height: 74px;

    @media(min-width: 768px) {
      height: 150px;
      position: relative;
    }
  }

  .logo {
		margin-right: 20px;
		width: 9rem;
		transition: width 0.2s ease-out;
    height: auto !important;
	}

  &.site-header--transformed {
    background-color: #fff;
		box-shadow: 4px 4px 9px -4px rgba(0, 0, 0, 0.45);
		height: 94px;

    .site-header__top {
      // display: none;
    }

		.logo {
			width: 7rem;
		}

    .main-top-header {
      height: 54px;
    }

    .header-icon-btn {
      width: 42px;
      height: 42px;
    }
  }

  .site-header__top {
    background: $indigo;
		color: $white;
    height: 40px;
    overflow: hidden;

    p {
      margin: 0 !important;
    }

    .contact_phone {
      p {
        margin: 0;
      }
    }

		> .container {
			min-height: 40px;
      height: 100%;

      .highlight h3,
      .highlight p,
      .highlight a {
        color: #fff;
      }
		}

		a {
			text-decoration: none;
			color: $white;

			@include lg-up {
				&:hover {
					color: $yellow;
				}
			}
		}
  }

  .site-header__top-office {
    background: $office-primary;
		color: $white;
    height: 40px;
    overflow: hidden;

    p {
      margin: 0 !important;
    }

    .contact_phone {
      p {
        margin: 0;
      }
    }

		> .container {
			min-height: 40px;
      height: 100%;

      .highlight h3,
      .highlight p,
      .highlight a {
        color: #fff;
      }
		}

		a {
			text-decoration: none;
			color: $white;

			@include lg-up {
				&:hover {
					color: $yellow;
				}
			}
		}
  }

  button.menu-item.relative {
    & > .menu-link {
      padding: 8px 10px;
    }
    & > .submenu {
      top: 32px;
    }
  }

  .header-icon-btn {
    border: 1px solid $black;
    border-radius: 50%;
    color: $black;
    background: $white;
    width: 46px;
    height: 46px;
    box-sizing: border-box;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &:hover {
      border: 1px solid $pink;
      background: $pink;
      color: $white;

      button {
        color: $white;
      }
    }

    @media (max-width: 375px) {
      width: 36px;
      height: 36px;
      align-items: center;
      margin: 0;
    }
  }

  .header-icon-btn_office {
    border: 1px solid $black;
    border-radius: 50%;
    color: $black;
    background: $white;
    width: 46px;
    height: 46px;
    box-sizing: border-box;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &:hover {
      border: 1px solid $office-primary;
      background: $office-primary;
      color: $white;

      button {
        color: $white;
      }
    }

    @media (max-width: 375px) {
      width: 36px;
      height: 36px;
      align-items: center;
      margin: 0;
    }
  }
}
.icon {
  opacity: 0.6;
  &:hover,
  &:focus {
    background-color: $color-icon-hover;
    opacity: 1;
  }
}
.right-icons {
  //for edge
  float: right;
}
.header-placeholder {
  height: 134px;

  @media (max-width: 375px) {
    height: 90px;
  }
}
.links {
  text-decoration: underline;

  &.checkout-links {
    text-decoration: none;
    border-radius: 24px;
    &:hover::after {
      height: 0;
      background: transparent;
    }
  }
}
.menu-link.main-menu-item {
  font-size: $font-size-small;
  color: #000;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  white-space: nowrap;

  &:hover:after {
    background-color: #000 !important;
  }

  &.active {
    background-color: #f0047f;
    color: #fff;
  }
  &.active2 {
    background-color: $office-primary;
    color: #fff;
  }
}

.menu-link.top-menu-item {
  color: $white;
  font-weight: 600;
  font-size: $font-size-small;
  padding: 8px 0px 8px 10px !important;

  &:hover::after {
    height: 0px !important;
  }
}

.social-links {
	@include lg-up {
		position: fixed;
		top: 50%;
		bottom: 50%;
		left: 16px;
	}

	&__title {
		display: none;
		@include lg-up {
			display: block;
			transform: rotate(-90deg);
			transform-origin: left top 0;
			font-size: .925rem;
		}
	}

	.links {
		margin: 0;
		padding: 0;
		list-style: none;
		&__item {
			display: inline-block;
			+ .links__item {
				margin-left: 1rem;
			}
			@include lg-up {
				display: block;
				+ .links__item {
					margin: .5rem 0 0;
				}
				a:hover svg path {
					stroke: $pacific-blue;
				}
			}
		}
	}
}

@media (max-width: 768px) {
  .row.middle-xs {
    margin: 0 -15px;

    &.py5 {
      margin: 0;
    }
    &.checkout {
      padding: 5px 0 !important;
    }
  }
  .col-xs-2:first-of-type {
    padding-left: 0;
  }
  .col-xs-2:last-of-type {
    padding-right: 0;
  }
  a,
  span {
    font-size: 12px;
  }
  .mobi-logo {
    a {
      width: 100%;
    }
    img {
      width: 100% !important;
    }
  }
}

.shop-info {
  display: none;
  visibility: hidden;
  
  @media(min-width: 768px) {
    display: block;
    
  }
}

.nav_rwd {
  align-items: start;
  padding-top: 15px;
}

.menu_position-rwd {
  position: absolute;
  top: 55px;
  left: 15px;
  display: flex;
  flex-wrap: wrap !important;

  @media(min-width: 992px) {
    padding: 0;
  }

  @media(min-width: 1200px) {
    flex-wrap: nowrap !important;
  }

  @media(min-width: 1540px) {
    position: unset;
  }
}

header.site-header--transformed {
  @media(min-width: 768px) {
    height: 190px;
  }

  @media(min-width: 1200px) {
    height: 155px;
  }

  @media(min-width:1540px) {
    height: 94px;
  } 
}

</style>
